<template>
	<div class="tc-schedule-list-group">
		<TCScheduleListRow
			v-bind:item="item"
			v-bind:watchSlide="watchSlide"
			v-on:schedule-list-row-slide="onScheduleListRowSlide"
			v-on:add-task-info="onClickAddTaskInfo"
			v-on:show-task-info="onClickShowTaskInfo"
			v-on:show-member-info="onClickShowMemberInfo"
			v-on:show-project-info="onClickShowProjectInfo"
			ref="parent"
		/>
		<TransitionExpand>
			<div v-if="isExpanded">
				<TCScheduleListRow
					v-for="child in item.children"
					v-bind:key="child.code"
					v-bind:parent="item"
					v-bind:item="child"
					v-bind:watchSlide="watchSlide"
					v-on:schedule-list-row-slide="onScheduleListRowSlide"
					v-on:show-task-info="onClickShowTaskInfo"
					v-on:delete-task="onClickDeleteTask"
					ref="children"
				/>
			</div>
		</TransitionExpand>
	</div>
</template>
<script>
import TCScheduleListRow from './TCScheduleListRow';
import TransitionExpand from './TransitionExpand';
export default {
	name: 'TCScheduleListRowGroup',
	components: {
		TCScheduleListRow,
		TransitionExpand,
	},
	props: [
		"item",
		"watchSlide",
		"scroll_to",
	],
	computed: {
		isExpanded: function() {
			return this.$store.getters['chart/isExpandedScheduleListRow'](this.item);
		},
	},
	methods: {
		onScheduleListRowSlide: function(e) {
			this.$emit('schedule-list-row-slide', e);
		},
		onClickAddTaskInfo: function(e) {
			this.$emit("add-task-info", e);
		},
		onClickShowTaskInfo: function(e) {
			this.$emit("show-task-info", e);
		},
		onClickShowMemberInfo: function(e) {
			this.$emit("show-member-info", e);
		},
		onClickShowProjectInfo: function(e) {
			this.$emit("show-project-info", e);
		},
		onClickDeleteTask: function(e) {
			this.$emit("delete-task", e);
		},
	},
	watch: {
		scroll_to: function() {
			let scroll_to = this.scroll_to;
			if (!scroll_to)
				return;
			if (scroll_to === this.item.code) {
				let el = this.$el;
				el.scrollIntoView(true);
			}
		},
	},
}
</script>
<style>
	.tc-schedule-list-group {
		border-bottom: 2px solid #a9a9a9;
	}
</style>
